import { useEffect } from 'react'
import { useNavigate } from 'react-router-dom'
import { useAuthMode } from '../../api/auth'
import { useAuthStore } from '../../store/authStore'
import LocalLoginForm from './LocalLoginForm'
import OidcLoginButton from './OidcLoginButton'

export default function LoginPage() {
  const navigate = useNavigate()
  const { data: authMode, isLoading } = useAuthMode()
  const user = useAuthStore((s) => s.user)

  useEffect(() => {
    if (user) navigate('/', { replace: true })
  }, [user, navigate])

  // Handle OIDC token in URL fragment (after OIDC redirect)
  useEffect(() => {
    const hash = window.location.hash
    if (hash.includes('accessToken=')) {
      const params = new URLSearchParams(hash.replace('#', '?'))
      const token = params.get('accessToken')
      if (token) {
        useAuthStore.getState().setAccessToken(token)
        window.history.replaceState(null, '', window.location.pathname)
        navigate('/', { replace: true })
      }
    }
  }, [navigate])

  if (isLoading) {
    return (
      <div className="flex items-center justify-center min-h-screen bg-background">
        <div className="animate-pulse text-muted-foreground font-mono">Loading...</div>
      </div>
    )
  }

  return (
    <div className="flex items-center justify-center min-h-screen bg-background">
      <div className="w-full max-w-sm space-y-6 p-8">
        <div className="text-center">
          <h1 className="text-2xl font-mono font-bold tracking-tight">Cheesy</h1>
          <p className="text-sm text-muted-foreground mt-1">Sandwich Emergency Platforms (Demo)</p>
        </div>

        {authMode?.mode === 'oidc' ? (
          <OidcLoginButton oidcIssuer={authMode.oidcIssuer} />
        ) : (
          <LocalLoginForm />
        )}
      </div>
    </div>
  )
}
